import type { Route } from '@angular/router';
import type { ConversationRouteData } from './conversation.models';

export interface ConversationRouteOptions extends ConversationRouteData {
  /** Usually `<list>/:requestId/conversation`; the component reads the `requestId` param. */
  path: string;
  canActivate?: Route['canActivate'];
  /** Extra route data for the host shell (e.g. `hidePageHeader`, `flowKey`). */
  data?: Record<string, unknown>;
}

/** Lazy route for the conversation thread, mounted inside the app's own layout. */
export function conversationRoute(options: ConversationRouteOptions): Route {
  const { path, canActivate, data, role, backRoute, description } = options;
  return {
    path,
    loadComponent: () =>
      import('./conversation-thread/conversation-thread.component').then(
        (m) => m.ConversationThreadComponent,
      ),
    ...(canActivate ? { canActivate } : {}),
    data: {
      title: 'Conversation',
      ...data,
      role,
      backRoute,
      description,
    } satisfies ConversationRouteData & Record<string, unknown>,
  };
}
